import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/nearkat_prompt.png'


const _withScopeId = n => (_pushScopeId("data-v-eea65b64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow flex flex-col space-y-3 md:space-y-0 md:grid md:grid-cols-3 md:grid-flow-row-dense md:gap-3" }
const _hoisted_2 = { class: "col-span-3 order-5 md:order-none cursor-default rounded-md shadow-lg relative nearkat-prompt flex h-32 px-4 sm:pl-6 sm:pr-16 items-center sm:space-x-4 justify-center sm:justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pt-3 h-full self-end hidden lg:block",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block flex-shrink-0 text-white text-xl" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Complete quests."),
  /*#__PURE__*/_createElementVNode("p", null, "Make transactions."),
  /*#__PURE__*/_createElementVNode("p", null, "Buy NFTs.")
], -1))
const _hoisted_5 = { class: "flex flex-col items-center space-y-4 w-64 text-white" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://near.university/",
  target: "_blank",
  rel: "noreferrer",
  class: "border-2 border-white rounded px-4 text-lg hover:bg-white hover:bg-opacity-10"
}, " Learn more ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoreWidget = _resolveComponent("ScoreWidget")!
  const _component_LevelWidget = _resolveComponent("LevelWidget")!
  const _component_BalanceWidget = _resolveComponent("BalanceWidget")!
  const _component_RankWidget = _resolveComponent("RankWidget")!
  const _component_BigChevron = _resolveComponent("BigChevron")!
  const _component_EarnNear = _resolveComponent("EarnNear")!
  const _component_StatsWidget = _resolveComponent("StatsWidget")!
  const _component_TransactionRateWidget = _resolveComponent("TransactionRateWidget")!
  const _component_TransactionHistoryWidget = _resolveComponent("TransactionHistoryWidget")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_ScoreWidget, { class: "row-span-2 order-1 md:order-none" }),
    _createVNode(_component_LevelWidget, { class: "row-span-1 order-2 md:order-none" }),
    _createVNode(_component_BalanceWidget, { class: "row-span-2 order-4 md:order-none" }),
    _createVNode(_component_RankWidget, { class: "row-span-1 order-3 md:order-none" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_BigChevron, { class: "hidden md:block h-full flex-shrink py-6 text-white" }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_EarnNear),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_StatsWidget, { class: "col-span-1 xl:col-span-2 order-6 md:order-none" }),
    _createVNode(_component_TransactionRateWidget, {
      class: "col-span-2 xl:col-span-1 order-7 md:order-none",
      style: {"min-height":"200px"}
    }),
    _createVNode(_component_TransactionHistoryWidget, { class: "col-span-3 xl:col-span-3 order-8 md:order-none" })
  ]))
}